import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import { LOGOUT_URL, HOME_URL } from '../../../../constants/url';
import logo from '../../../../img/logo-plain-white.png';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  title: {
    color: 'white',
    paddingLeft: 30,
  }
}));

const Topbar = props => {
  const { className, onSidebarOpen, ...rest } = props;

  const classes = useStyles();

  const [notifications] = useState([]);

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      style={{backgroundColor: '#4b9451'}}
    >
      <Toolbar>
        <RouterLink to={HOME_URL}>
          <img
            height={36}
            alt="Logo"
            src={logo}
          />
        </RouterLink>
        <Typography variant="h5" className={classes.title}>TLS Manager</Typography>
        <div className={classes.flexGrow} />
        <Hidden mdDown>
          {false && <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>}

          <RouterLink 
            to={LOGOUT_URL}
            component={IconButton}
            className={classes.signOutButton}
            underline="none"
            color="inherit"
            title="Cerrar sesión"
          >
            <InputIcon />
          </RouterLink>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
